import { useEffect, useState } from 'react'
import api from '@/utils/api'
import { getForumSpeakerVisibility } from '@/utils/forumSpeakers'

export default function useForumSpeakerVisibility(year) {
  const [visibility, setVisibility] = useState(() => getForumSpeakerVisibility())

  useEffect(() => {
    let active = true
    setVisibility(getForumSpeakerVisibility())
    api.get('/api/agenda/list', { year }).then(list => {
      if (active) setVisibility(getForumSpeakerVisibility(list))
    }).catch(() => {
      if (active) setVisibility(getForumSpeakerVisibility())
    })
    return () => { active = false }
  }, [year])

  return visibility
}
